module.exports = __webpack_public_path__ + "img/The_present_past_1.jpg";